import { useRenderer } from '@fox/atoms/hooks/use-renderer';
import { IBlockDefinition, IBlockProps } from '@fox/blocks/contracts/block';
import { useSubscribeTopicWithHandler } from '@fox/extensions/src/extension-hooks';
import { FORM_BLOCK_TYPE } from '../../../form-block-types';
import { useFormRuntimeContext } from '../../form-runtime-context';
import { FORM_SET_ANSWERS, SurveyState } from '../../form-runtime-context/contracts';
import { RenderBlockComponent } from '../../render-block-component';
import { FormBlockProps } from './contracts';
import { FormPagination } from './form-pagination';

function FormBlock({ props }: IBlockProps<FormBlockProps>) {
	const { surveyState } = useFormRuntimeContext();
	if (!props.innerLayout?.layouts) return <></>;
	const render = useRenderer();
	//when we wholsesale set answers we just re-render the form block
	useSubscribeTopicWithHandler(FORM_SET_ANSWERS, () => {
		render();
	});
	const layouts = props.innerLayout.layouts;
	return (
		<>
			{layouts.map(layout => {
				return <RenderBlockComponent {...layout} key={layout.id} />;
			})}
			{surveyState !== SurveyState.submitted ? <FormPagination /> : null}
		</>
	);
}

export const FormBlockRunTime: IBlockDefinition<FormBlockProps> = {
	type: FORM_BLOCK_TYPE,
	Component: FormBlock
};
